import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import SvgIcon from '@material-ui/core/SvgIcon';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import { Link } from 'react-router-dom';


class TmxRow extends Component {
	constructor() {
		super();
	}
	
	render() {
		let formatedName = this.props.name;
		if(!this.props.validation){
			formatedName=<span className="haveErrors">{this.props.name}</span>;
		}
		return (
			<TableRow key={this.props.id}>
			<TableCell>{this.props.id}</TableCell>
			<TableCell>{formatedName}</TableCell>
			<TableCell>{this.props.languages}</TableCell>
			<TableCell>{this.props.customers}</TableCell>
			<TableCell><a target="_blank" style={{textDecoration: 'none'}} href={this.props.links.href+"/?access_token="+this.props.accessToken}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}}>&#59408;</Icon></a> | <Link style={{textDecoration: 'none'}} to={`/tmxForm/${this.props.id}`}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}}>&#59392;</Icon></Link></TableCell>
			</TableRow>
		);
	}
}

export default TmxRow;